import { Button } from "@prima-afp/prima-ui-elements/dist/core";
import CryptoJS from "crypto-js";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { sendToData } from "../../constants/sendToDataLayer";
import { updateUrl } from "../../constants/updateUrl";
import { ValidStepFundType } from "../../constants/validate";
import {
  useDispatchDigitalTransfersContext,
  useStateDigitalTransfersContext,
} from "../../context/DigitalTransfersContext";
import { useCatchFetch } from "../../hooks/useCatchFetch";
import {
  SendSaveEmployer,
  SendSaveFundType,
  checkTocAttempts,
} from "../../services";
import { ButtonsContainer, DivBackButton } from "./styles";

//importación del boton para toc
import { TocBiometricRoutes } from "../../constants";
import * as MODULES_CONFIG from "../../../../router/config";
import { getUtmData, getDataDevice } from "../../constants/sendToDataLayer";
import { ButtonFloating } from "../../components/ButtonFloating/ButtonFloating";
import  PermissionsModal from "../StepFundType/PermissionsModal";

export const SendButton = ({ buttonRef }) => {
  const {
    userWeb,
    userWebTransfer,
    codeValidateDocument,
    heldPosition,
    urlFlow,
    lastStep,
  } = useStateDigitalTransfersContext();
  const { SendFetch, TransparentSendFetch, SetLoading } = useCatchFetch();
  const dispatch = useDispatchDigitalTransfersContext();
  const history = useHistory();
  const [formDisabled, setFormDisabled] = useState(true);
  const variantes = { 5: "tipo_a", 6: "tipo_b", 7: "tipo_c" };
  const [permissionsWarning, setPermissionsWarning] = useState(null);
  const [showPreventiveModal, setShowPreventiveModal] = useState(null);
  const urlPublicZoneWithImages =  "https://www.prima.com.pe/public-zone/images/webTransactional/biometriaToc/";

  useEffect(() => {
    const isFormDisabled =
      !userWeb.workerType ||
      userWeb.codeFundType == null ||
      heldPosition == null ||
      (heldPosition &&
        (userWeb.pepInstitutionName === "" || userWeb.pepPositionHeld === ""));
      
    setFormDisabled(isFormDisabled);
  }, [userWeb, heldPosition]);

  const BackStep = () => {
    dispatch({
      type: "BACK_FUND_TYPE_STEP",
    });
    dispatch({ type: "FIELD", payload: { field: "stepCurrent", value: 1 } });
    updateUrl(history, window.location.href, "/pasos0");
  };

  const showErrorModal = (idModal, content) => {
    dispatch({
      type: "SET_CONFIG_MODAL",
      payload: { idModal, content },
    });
  };

  const saveEmployer = async () => {
    const bodySaveEmployeer = {
      documentType: userWeb.documentType,
      documentNumber: userWeb.documentNumber,
      workerType: "I",
      rucEmployer: null,
      nameEmployer: null,
    };
  
    const resSaveEmployeer = await SendFetch(SendSaveEmployer(bodySaveEmployeer));
    if (resSaveEmployeer.code === 0) {
      dispatch({
        type: "FIELD_SECOND",
        payload: { field1: "userWeb", field2: "workerType", value: null },
      });
      showErrorModal(
        "btn-step2-error-employeer-send",
        "Seleccione su fondo de nuevo"
      );
      return false;
    }
    return true;
  };

  const saveFundType = async (type) => {
    const bodySave = {
      documentType: userWeb.documentType,
      documentNumber: userWeb.documentNumber,
      fundType: userWeb.fundType,
      promoterCode: userWeb.promoterCode,
      heldPosition: heldPosition,
      pepInstitutionName: userWeb.pepInstitutionName,
      pepPositionHeld: userWeb.pepPositionHeld,
    };
  
    const res = await SendFetch(SendSaveFundType(bodySave));
    if (res) {
  
      // Metadata creation
      const metadata = {
        metadata_1: `¿que tipo de trabajador eres? - ${
          userWeb.workerType === "D"
            ? "trabajo de forma dependiente para una empresa"
            : "trabajo de forma independiente"
        }`,
        metadata_2: `¿ha desempeñado un cargo publico en el peru o en el extranjero durante los ultimos 5 años? - ${
          heldPosition ? "si" : "no"
        }`,
        metadata_3: `tipo de fondo - fondo ${userWeb.fundType}`,
        status: codeValidateDocument === 4 ? "no_reniec" : "reniec_activo",
        variante:  "original",
      };
  
      const payload = {
        section: "paso 2",
        ...metadata,
        option: "siguiente",
        count_2: 1,
        dni: userWeb.documentNumber,
        telefono: userWeb.phoneNumber,
        email: userWeb.email,
        edad: userWeb.age,
      };
  
      sendToData(window.location.href, "step", "paso_2", payload, urlFlow);
  
      if (lastStep < 3) {
        dispatch({ type: "FIELD", payload: { field: "lastStep", value: 3 } });
      }
  
      saveUserWebInSessionStorage(type);
      dispatch({ type: "COMPLETE_FUND_TYPE_STEP", payload: userWebTransfer });
      //startValidation();
      return true;
    }
    return false;
  };

  const saveUserWebInSessionStorage = () => {
    const payloadContext = {
      age: userWeb.age,
      documentType: userWeb.documentType,
      documentNumber: userWeb.documentNumber,
      tcConfirmation: userWeb.tcConfirmation,
      adpConfirmation: userWeb.adpConfirmation,
      pepInstitutionName: userWeb.pepInstitutionName,
      pepPositionHeld: userWeb.pepPositionHeld,
      heldPosition: userWeb.heldPosition,
      firstName: userWeb.firstName,
      email: userWeb.email,
      phoneNumber: userWeb.phoneNumber,
      address: userWeb.address,
      workerType: userWeb.workerType,
      rucEmployer: userWeb.rucEmployer,
      tradeNameEmployer: userWeb.tradeNameEmployer,
      codeFundType: userWeb.codeFundType,
      fundType: userWeb.fundType
    };
  
    const secretKey = sessionStorage.getItem("timestampFirstQuery");
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(payloadContext),
      secretKey
    ).toString();
    sessionStorage.setItem("userWeb", encryptedPayload);
  };
  
  const SaveDataStep2 = async () => {
    const validation = ValidStepFundType(userWeb, heldPosition, false);
  
    if (validation) {
      showErrorModal("btn-step2-error-fund-type-send", validation);
      return "ERROR_FIELDS_DATA_STEP2";
    }
  
    const employerSaved = await saveEmployer();
    if (!employerSaved) return "ERROR_SAVE_EMPLOYER";
  
    const fundTypeSaved = await saveFundType();
    if (!fundTypeSaved) {
      showErrorModal(
        "btn-step2-error-employeer-send",
        "Seleccione su fondo de nuevo"
      );
      return "ERROR_SAVE_FUND_TYPE";
    }
  
    return "SAVE_FUND_TYPE_OK";
  };

  const checkCameraPermission = async () => {
      try {
          const stream = await navigator.mediaDevices.getUserMedia({ video: true });
          // Detener el stream de video para liberar la cámara
          stream.getTracks().forEach(track => track.stop());
          return true;
      } catch (error) {
          return 'false';
      }
  };

  const askPermissisons = async () => {    
    const statusPermisos = await checkCameraPermission();    
    setShowPreventiveModal(false); 
    if(statusPermisos === 'false' || statusPermisos === false){                      
        setPermissionsWarning(false);
    } else if(statusPermisos === 'true' || statusPermisos === true) {
        goNextStep(true); 
    } 
  };

  const BlockedCamera= () => {
      window.location.reload();       
  };

  const deviceInfo = getDataDevice();

  const GoToBiometricValidation = async () => {
    navigator.permissions.query({ name: 'camera' })
        .then((permissionStatus) => {
            if(permissionStatus.state === 'granted'){
                goNextStep(true);
            }else if(permissionStatus.state === 'denied'){
                setPermissionsWarning(false);
            }
            else if(permissionStatus.state === 'prompt' || permissionStatus.state === null){     
                setShowPreventiveModal(true);
            }
        })
        .catch((error) => {
            console.error('Error al comprobar el permiso de la cámara:', error);
        });    

  };

const isValidDocumentNumber = (doc) => {
  return doc !== null && doc !== "" && /^[0-9]{8}$/.test(doc);
};

const handleErrorNextStep = (dni) => {
  dispatch({
    type: "NOT_VALID_DOCUMENT",
    payload: {
      idModal: "btn-error-documentIdentity",
      content: "Hubo un inconveniente en el proceso, por favor, vuelve a intentarlo en unos minutos.",
      changeLoading: false,
      textButton: "Volver",
      className: "centerContent",
    },
  });

  dispatch({
    type: "FIELD",
    payload: { field: "stepCurrent", value: 0 },
  });

  sendToData(window.location.href, "step", "error", {
    section: "paso 2",
    option: "hubo un inconveniente en la llamada a biometría toc, intente otra vez",
    dni,
  }, urlFlow);
};

const proceedToToc = (documentNumber) => {
  const urlTocConfig = TocBiometricRoutes(
    MODULES_CONFIG.genericProcedureBiometricTOCConfig.pathBase
  ).START_VALIDATION_PROCESS;

  const utmParams = getUtmData({}, window.location.href);
  const stateData = {
    documentNumber,
    utmParams,
    fromConsumerModule: true,
  };
  sessionStorage.setItem("location-state-store", JSON.stringify({ state: stateData }));
  sessionStorage.setItem("skipReco", "NO_SKIP");
  sessionStorage.setItem("flowType", "SIN_ASESOR");

  history.push({
    pathname: urlTocConfig,
    state: stateData,
  });
};

const goNextStep = () => {
  const { documentNumber, useToc } = userWeb;

  if (useToc && isValidDocumentNumber(documentNumber)) {
    SendFetch(checkTocAttempts(documentNumber))
      .then(() => proceedToToc(documentNumber))
      .catch(() => handleErrorNextStep(documentNumber));
  }
};

  const Send = async () => {
    SetLoading(true);
    const result = await SaveDataStep2();
    if (result.startsWith("ERROR")) {
    }else if(result == 'SAVE_FUND_TYPE_OK'){
      await GoToBiometricValidation();
    }
    SetLoading(false);
  };

  const isDisabled = () => {
    return (
      !userWeb.workerType ||
      userWeb.codeFundType == null ||
      heldPosition == null ||
      (heldPosition &&
        (userWeb.pepInstitutionName === "" || userWeb.pepPositionHeld === ""))
    );
  };

  return (
    <ButtonsContainer>
      {window.innerWidth < 451 ? (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Button
            id="btn-fund-type-send"
            onClick={() => Send()}
            ref={buttonRef}
            disabled={isDisabled()}
            className={`newUiBtn ${formDisabled ? "disabledBtn" : "enabledBtn"}`}
          >
            Continuar
          </Button>
          <DivBackButton className="newUiBtn" onClick={BackStep}>
            Regresar
          </DivBackButton>
        </div>
      ) : (
        <div
          id="wrapperButtonsStep2"
          style={{ width: "100%", display: "flex" }}
        >
          <Button
            id="btn-fund-type-send-test"
            onClick={() => Send()}
            ref={buttonRef}
            disabled={isDisabled()}
            className={`newUiBtn ${formDisabled ? "disabledBtn" : "enabledBtn"}`}
          >
            Continuar
          </Button>
        </div>
      )}
      {!isDisabled() && (
        <ButtonFloating
          buttonRef={buttonRef}
          action={() => Send()}
          text="Continuar"
        />
      )}

      <PermissionsModal        
        permissionsWarning={permissionsWarning}
        showPreventiveModal={showPreventiveModal}
        deviceInfo={deviceInfo}
        urlPublicZoneWithImages={urlPublicZoneWithImages}
        BlockedCamera={BlockedCamera}
        askPermissions={askPermissisons}
      />

    </ButtonsContainer>

  );
};